import { useCallback, useMemo } from 'react';
import { useIoContext } from "../../../../contexts";
import { useServiceBillingDetails } from "../../../../hooks/reactQuery/queries/useServiceBillingDetails";
import { useLocaleKeys } from "../../../../i18n";
import { isAfterOrEqual, format, startOfDay, isBefore } from "../../../../infra/utils/dates-fns";
import { serviceModel } from "../../../../models";
import { StartAutomaticBillingAtControlDropdownMenuItem } from "../StartAutomaticBillingAtControl";
export const useCallOuts = _ref => {
  let {
    testIds,
    relationshipEffectiveDate,
    service,
    selectedItem,
    isChecked,
    isAmendedService
  } = _ref;
  const {
    StartAutomaticBillingAtControlTestIds
  } = testIds;
  const {
    getNow
  } = useIoContext();
  const {
    t
  } = useLocaleKeys('components.serviceAdvancedSettings.startAutomaticBillingAtControl.callouts');
  const getToday = useCallback(() => startOfDay(getNow()), [getNow]);
  const isProrated = serviceModel.isProrated(service);
  const isBilledUpfront = serviceModel.isBilledUpfront(service);
  const {
    nextBillingDate,
    periods
  } = useServiceBillingDetails({
    service,
    relationshipEffectiveDate: relationshipEffectiveDate
  });
  const startBillingAt = serviceModel.startBillingAt(service);
  const shouldShowProrateWarning = useMemo(() => {
    if (!isProrated && isBilledUpfront && startBillingAt && nextBillingDate) {
      return nextBillingDate.getTime() !== startBillingAt.getTime();
    }
    return false;
  }, [nextBillingDate, startBillingAt, isProrated, isBilledUpfront]);
  return useMemo(() => {
    const _callouts = [];
    if (!isChecked) {
      return _callouts;
    }
    if (selectedItem === StartAutomaticBillingAtControlDropdownMenuItem.SpecificDate && startBillingAt) {
      const formattedDate = format(startBillingAt, 'MMM d, yyyy');
      if (!isAmendedService && isAfterOrEqual(startBillingAt, getToday())) {
        if (relationshipEffectiveDate) {
          _callouts.push({
            dataTestid: StartAutomaticBillingAtControlTestIds.Callouts.FutureDate(),
            text: t.futureDate({
              date: formattedDate
            })
          });
        } else {
          _callouts.push({
            dataTestid: StartAutomaticBillingAtControlTestIds.Callouts.OnAcceptanceDate(),
            text: t.onAcceptanceDate({
              date: formattedDate
            })
          });
        }
      }
      if (shouldShowProrateWarning) {
        _callouts.push({
          dataTestid: StartAutomaticBillingAtControlTestIds.Callouts.Proration(),
          text: t.proration()
        });
      }
      if (periods && periods > 0 && isBefore(startBillingAt, getToday())) {
        _callouts.push({
          dataTestid: StartAutomaticBillingAtControlTestIds.Callouts.PriorPeriods(),
          text: t.priorPeriods({
            periods,
            date: formattedDate
          })
        });
      }
    }
    return _callouts;
  }, [selectedItem, isChecked, startBillingAt, shouldShowProrateWarning, periods, relationshipEffectiveDate, isAmendedService, t, StartAutomaticBillingAtControlTestIds.Callouts, getToday]);
};